import React, { Component } from 'react';
import { Image, Button } from 'semantic-ui-react'
// import './Slide.css';
class Slide extends Component {
  constructor(props){
    super(props)

  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selected == false && this.props.selected) {
      const maxRetries = 3;
      const retryDelay = 1000; // 1 second delay between retries
      let retryCount = 0;
      
      const trySetCircuit = async () => {
        try {
          this.props.set_circuit(this.props.circuit, !window.thumbs.state.opening);
          this.setState({ open: this.state.open, selected: true });
        } catch (error) {
          if (retryCount < maxRetries) {
            retryCount++;
            console.log(`Retry attempt ${retryCount} of ${maxRetries}`);
            await new Promise(resolve => setTimeout(resolve, retryDelay));
            trySetCircuit();
          } else {
            console.error('Failed to set circuit after maximum retries:', error);
          }
        }
      };
  
      trySetCircuit();
    }
  }

  state = { open: false, selected: false }


  render() {

    const borderStyle = {
      borderWidth: this.props.selected ? 3 : 1,
      position: 'relative',
      backgroundColor: this.props.circuit.bg_color,
      borderStyle: 'solid', borderColor: this.props.selected ? 'coral' : 'gray', paddingBottom: 8
    }

    return (
      <div className="slide"
      style={borderStyle} onClick={()=> {
        if (!window.thumbs.state.opening){
          window.thumbs.sync();
          setTimeout(()=>{
            this.props.select(this.props.number-1)
          }, 1)
        }
      }} >
        {this.props.circuit.base64_shapshot != "" &&
        <Image src={"data:image/png;base64," +this.props.circuit.base64_shapshot} size='small' />
        }
        <div style={{height: 7, width: '100%', position: 'absolute', left: 0, bottom: 5}}>
        <p className={this.props.selected ? "slide_caption_selected" : "slide_caption"} >
            {this.props.number}
        </p>
        {!this.props.single &&
            <div>
        <Button onClick={(e)=>{

          e.stopPropagation();
          this.props.setConfirm(this.props.number-1)
          }
        }
        style={{position: 'relative', top: -27, padding: 0, backgroundColor: 'transparent', color: 'red' }}  icon='delete' size='mini' />

              {this.props.index != 0 && this.props.selected &&
              <Button onClick={(e) => {
                e.stopPropagation();
                this.props.moveSlide(this.props.index, -1)
              }}
                      id="slide_mover"
                      style={{position: 'relative', top: -28, left: 50, backgroundColor: 'transparent', color: '#333333'}}
                      icon='angle up' size='mini'/>
              }
              {!this.props.last && this.props.selected &&
          <Button onClick={(e)=>{
          e.stopPropagation();
          this.props.moveSlide(this.props.index, 1)}}
          id="slide_mover"
          style={{position: 'relative', top: -28, left: this.props.index == 0 ? 50 :20, backgroundColor: 'transparent', color: '#333333' }}
          icon='angle down' size='mini' />}
          </div>
          }



        </div>
      </div>
    );
  }
}

export default Slide;
